import type { EpocusEncounter } from "$global-providers/rxdb-provider/collections/epocus-encounter";
import { formatDicomPatientName } from "./dicom-patient-name";

const UNKNOWN_PATIENT_LABEL = "Unknown Patient";

export const encounterDisplayLabel = ({
  patientName,
  accessionNumber,
}: Pick<EpocusEncounter, "patientName" | "accessionNumber">): string =>
  formatDicomPatientName(patientName) ||
  accessionNumber?.trim() ||
  UNKNOWN_PATIENT_LABEL;
